import React, { useEffect, useState } from "react";
import LeadsTable from "../Table/LeadsTable";
import LeadsFilterSearch from "./LeadsFilterSearch";

import { Alert, AlertTitle, Grid } from "@mui/material";
import LeadersSearchHeader from "./LeadersSearchHeader";
import {
  deleteLeadAction,
  leadFindAction,
  leadFilterAction,
  allLeadFindAction,
  allLeadsFindAction,
  allLeadFindActionWithoutPagination
} from "../../actions/leadActions/leadActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { findUserAction } from "../../actions/adminAuthAction";
import DownloadExcel from "../extraComponents/DownloadExcel";
import DownloadPdf from "../extraComponents/DownloadPdf";
import { SUCCESS_TRUE_MSG_ERR } from "../../constants/roleManagmentConstant";
import { successTrueMsgAction } from "../../actions/globalAction";
import {
  LEAD_BULKUPLOAD_SUCCESS,
  LEAD_CREATE_SUBMIT_ERR,
  LEAD_CREATE_SUBMIT_SUCCESS,
  LEAD_OWNER_CHANGE_SUCCESS
} from "../../constants/leadConstant";
import Loader from "../LoaderComponent/Loader"
import axios from "axios";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";

function All_leadListTable(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [counsilorNote, setCounsilorNote] = useState({});
  const [teleCallerNote, setTeleCallerNote] = useState({});
  const [marketingNote, setMarketingNote] = useState({});

  const [data, setData] = useState([]);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [viewedColumn, setViewedColumn] = useState([]);
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [searchPagination, setSearchPagination] = useState(false)
  const [filterPagination, setFilterPagination] = useState(false)
  const [searchValue, setSearchValue] = useState('');
  const [currentFilterData, setCurrentFilterData] = useState(null);

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  const { allLeadFindLoading, allLeadFindSuccess } = useSelector((state) => state.allLeadFind)

  const { allLeadFindWithoutPaginationSuccess } = useSelector((state) => state.allLeadFindWithoutPagination)

  let { leadAddSuccess, leadAdderror } = useSelector((state) => {
    return state.leadAdd;
  });

  let { leadBulkUploadSuccess, leadBulkUploadError } = useSelector((state) => {
    return state.leadBulkUpload;
  });

  let { leadDeleteSuccess } = useSelector((state) => {
    return state.deleteLead;
  });

  let { leadOwnerSuccess, leadOwnererror } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  let { loginFindSuccess } = useSelector((state) => {
    return state.findUser;
  });

  let { successAlertMsgSuccess, successAlertMsgErr } = useSelector((state) => {
    return state.successTrueMsg;
  });

  let { leadFilterRequestSuccess } = useSelector((state) => state.leadFilter);

  useEffect(() => {
    dispatch(findUserAction());
  }, [dispatch]);

  // Initial data load - only when needed (not filter/search active)
  useEffect(() => {
    if (!searchPagination && !filterPagination || leadOwnerSuccess) {
      dispatch(allLeadsFindAction(pagiantionEntry, paginationPageNumber));
      dispatch(allLeadFindActionWithoutPagination());
    }
  }, [
    dispatch,
    leadAddSuccess,
    leadDeleteSuccess,
    leadOwnerSuccess,
    leadBulkUploadSuccess,
    pagiantionEntry,
    paginationPageNumber,
    searchPagination,
    filterPagination,
    successAlertMsgSuccess
  ]);

  // Handle filter changes
  useEffect(() => {
    if (leadFilterRequestSuccess || reset) {
      setFilterPagination(true);
      setPaginationPageNumber(1);
      setLeadData(leadFilterRequestSuccess?.allLeads);

      const latestTeleCallerNote = leadFilterRequestSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      const latestCounsilorNote = leadFilterRequestSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      const latestMarketingNote = leadFilterRequestSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_marketing_notes &&
            current.lead_marketing_notes.length > 0
          ) {
            const latestInCurrent = current.lead_marketing_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_marketing_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
      setMarketingNote(latestMarketingNote);
    }
  }, [leadFilterRequestSuccess, reset, successAlertMsgSuccess]);

  // Handle regular all leads data
  useEffect(() => {
    if (allLeadFindSuccess || reset) {
      setLeadData(allLeadFindSuccess?.allLeads);
      const latestTeleCallerNote = allLeadFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      const latestCounsilorNote = allLeadFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      const latestMarketingNote = allLeadFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          if (
            current.lead_marketing_notes &&
            current.lead_marketing_notes.length > 0
          ) {
            const latestInCurrent = current.lead_marketing_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_marketing_notes[0]
            );

            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      );

      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
      setMarketingNote(latestMarketingNote);
    }
  }, [allLeadFindSuccess, reset, successAlertMsgSuccess]);

  useEffect(() => {
    if (leadOwnerSuccess) {
      if (
        leadOwnerSuccess?.taskOwner == "admin" ||
        leadOwnerSuccess?.leadOwnerName == "Gsl Marketing" ||
        leadOwnerSuccess?.approval == true
      ) {
        Swal.fire({
          title: `<span style="font-size:20px;">Lead ${leadOwnerSuccess.data} Changed!</span>`,
          text: "Successfully.",
          icon: "success",
          customClass: {
            popup: "my-custom-popup",
            title: "my-custom-title",
            content: "my-custom-content",
            confirmButton: "my-confirm-button"
          },
          showConfirmButton: true
        });
        dispatch({ type: LEAD_OWNER_CHANGE_SUCCESS, payload: false });
      } else {
        if (leadOwnerSuccess?.data == "branch manager") {
          Swal.fire({
            title: `<span style="font-size:20px;">Lead ${leadOwnerSuccess.data} Changed!.Waiting for approval</span>`,
            icon: "warning",
            customClass: {
              popup: "my-custom-popup",
              title: "my-custom-title",
              content: "my-custom-content",
              confirmButton: "my-confirm-button"
            },
            showConfirmButton: true
          });
          dispatch({ type: LEAD_OWNER_CHANGE_SUCCESS, payload: false });
        }
      }
    }
  }, [leadOwnerSuccess, successAlertMsgSuccess]);

  useEffect(() => {
    if (leadAddSuccess && successAlertMsgSuccess) {
      Swal.fire("Added!", "Lead created successfully.", "success").then(
        (value) =>
          dispatch({ type: LEAD_CREATE_SUBMIT_SUCCESS, payload: false })
      );
      dispatch(successTrueMsgAction(false));
    }
    if (leadAdderror && successAlertMsgErr) {
      Swal.fire("Error!", leadAdderror, "error").then((value) =>
        dispatch({ type: LEAD_CREATE_SUBMIT_ERR, payload: false })
      );
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [
    leadAddSuccess,
    leadAdderror,
    successAlertMsgSuccess,
    successAlertMsgErr
  ]);

  useEffect(() => {
    if (leadBulkUploadSuccess && successAlertMsgSuccess) {
      Swal.fire("Added!", "Lead Uploaded successfully.", "success").then(
        (value) => dispatch({ type: LEAD_BULKUPLOAD_SUCCESS, payload: false })
      );
      dispatch(successTrueMsgAction(false));
    }
  }, [leadBulkUploadSuccess, successAlertMsgSuccess]);

  useEffect(() => {
    setData(
      leadData
        ?.map((lead, index) => {
          const leadObject = {
            id: lead.id,
            sl: index + 1,
            name: lead?.firstName,
            email: lead.email,
            countryId: lead.countryId,
            phone: lead.mobileNumber,
            whatsappNumber: lead.whatsappNumber,
            passportNumber: lead.lead_personal_details?.[0]?.passportNumber,
            preferredCountry: lead.preferredCountryId,
            leadSource: lead.leadSource,
            leadOwner:
              loginFindSuccess?.role?.roleName !== "branch manager" ||
                loginFindSuccess?.is_Lead_B_to_C == true
                ? lead.leadOwnerName || "-"
                : null,
            status: lead.status,
            priority: lead.priority || "-",
            leadCity: lead.location,
            branchId: lead.branchId,
            tags: lead?.DuplicateLead,
            registrationFeeTag: lead?.registrationFeeApproval,
            tutionFeeTag: lead?.tuitionFeeApproval,
            deferralTag: lead?.deferralApproval,
            recallTag: lead?.leadRecallStatus,
            enrollTag: lead?.leadEnrollmentApprovalStatus,
            dropTag: lead?.dropApproval,
            ownerChangeTag: lead?.ownerChangeApproval,
            leadEmailEditTag: lead?.leadEmailApproval,
            isSourceEdit: lead?.IsleadSourceChanged,
            leadSourceEditTag: lead?.leadSourceApproval,
            leadPhoneNumberEditTag: lead?.leadPhoneNumberApproval,
            leadDocumentEditTag: lead?.leadDocumentApproval,
            leadPassportVerifyTag: lead?.isPassportVerificationRequest,
            leadPassportEditTag: lead?.leadPassportEdit,
            leadBranch: lead?.branch_master?.branchName || "-",
            leadCounsilor: lead?.counsilorID ? lead?.counsilorID : "-",
            // loginFindSuccess?.is_Lead_B_to_C == true
            //   ? lead?.counsilorID || "-"
            //   : null,
            CounsilorNote:
              counsilorNote?.leadId == lead?.id
                ? counsilorNote?.counsilorNote
                : "-",
            leadTeleCaller:
              lead?.teleCallerId || "-",
            TeleCallerNote:
              teleCallerNote?.leadId == lead?.id
                ? teleCallerNote?.teleCallerNote
                : "-",
            marketingNote:
              marketingNote?.leadId == lead?.id
                ? marketingNote?.marketingNote
                : "-"
          };

          return leadObject;
        })
        .filter(Boolean)
    );
  }, [leadData, viewedColumn]);

  // Handle search input change
  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim();
      setSearchValue(newSearchValue);

      if (newSearchValue === "") {
        setSearchPagination(false);
        setLeadData(allLeadFindSuccess?.allLeads);
        return;
      }

      setPaginationPageNumber(1);
    } catch (error) {
      console.error(error);
    }
  }

  // Handle search - this performs the actual search API call
  const searchHandleChange = async (e) => {
    try {
      const newSearchValue = e.target.value.trim();

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(allLeadsFindAction(pagiantionEntry, paginationPageNumber));
        return;
      }

      setSearchValue(newSearchValue);
      setSearchPagination(true);
      setFilterPagination(false);

      fetchSearchResults(newSearchValue, paginationPageNumber);
    } catch (error) {
      console.error(error);
    }
  }

  // Fetch search results based on current search value and page
  const fetchSearchResults = async (value, pageNum) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/lead/searchlead?q=${value}
        &limit=${pagiantionEntry}&pagenumber=${pageNum}&id=${UserId}`, config);

      setSearchPaginationCount(data?.totalCount);
      setLeadData(data?.payload);
    } catch (error) {
      console.error(error);
    }
  };

  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);
  const [columnVisibilityData, setColumnVisibilityData] = useState([]);

  // material Table
  const columnss = [
    {
      title: "Sl no",
      field: "sl"
    },
    {
      title: "Name",
      field: "name",
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Phone",
      field: "phone",
    },
    {
      title: "What's App Number",
      field: "whatsappNumber",
    },
    {
      title: "Passport number",
      field: "passportNumber",
    },
    {
      title: "Tags",
      field: "Tags",
    },
    {
      title: "Preferred Country",
      field: "preferredCountry",
    },
    {
      title: "Lead Source",
      field: "leadSource",
    },
    {
      title:
        loginFindSuccess?.role?.roleName !== "branch manager" ||
          loginFindSuccess?.is_Lead_B_to_C == true
          ? "Lead Owner"
          : null,
      field: "leadOwner",
    },
    {
      title: "Lead Branch",
      field: "leadBranch",
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Priority",
      field: "priority",
    },
    {
      title: "Lead Place",
      field: "leadCity",
    },
    {
      title: "Telecaller",
      field: "TeleCaller",
    },
    {
      title: "Telecaller note",
      field: "telecallerNote",
    },
    {
      title:
        loginFindSuccess?.role == null ||
          loginFindSuccess?.isManager ||
          loginFindSuccess?.is_Lead_B_to_C == true ||
          loginFindSuccess?.role?.roleName !== "counsellor"
          ? "Counsilor"
          : null,
      field: "Counsilor",
    },
    {
      title: "Counsilor note",
      field: "counsilorNote",
      filtering: false
    },
    {
      title: "Marketing note",
      field: "marketingNote",
      filtering: false
    },
    {
      title: "action",
      field: "action",
      filtering: false
    }
  ];

  const pdfDownloadClick = () => {    
    const excludedFields = ["sl", "Tags", "action", "telecallerNote", "counsilorNote", "marketingNote"];
    const filteredColumns = columnss.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    );    

    DownloadPdf(filteredColumns, data, "Lead_Management", "Lead Details")
  }

  useEffect(() => {
    const columnVisibilityData = columnss.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col;
      }
    });
    setColumnVisibilityData(columnVisibilityData);
  }, [viewedColumn]);


  const excelDownloadClick = () => {
    const excludedFields = ["Tags", "action", "telecallerNote", "counsilorNote", "marketingNote"];
    const filteredColumns = columnss.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    );    

    DownloadExcel(filteredColumns, data, "Lead_Managment");
  };

  const toggleNameColumn = (status, columnName) => {
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName)
          ? prevColumns
          : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  const LeadFilterFunction = (filterData) => {
    try {
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      setFilterPagination(true);
      setPaginationPageNumber(1);
      dispatch(leadFilterAction(filterData, pagiantionEntry, 1));
    } catch (error) {
      console.error(error);
    }
  }

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(allLeadsFindAction(pagiantionEntry, 1));
  };

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(leadFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(allLeadsFindAction(value, 1));
    }
  }

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };

  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(leadFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(allLeadsFindAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (!hasPrivilege("All Leads") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <LeadersSearchHeader
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        data={allLeadFindSuccess?.allLeads}
        component={"AllLeads"}
        subMenu="All Leads"
        column={columnss}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="lead"
            data={allLeadFindWithoutPaginationSuccess?.allLeads}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
            component="lead"
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
          {allLeadFindLoading ? (
            <Loader />
          ) : data?.length === 0 ? (
            <TableNoItemComponent />
          ) : (
            <LeadsTable
              toggle={props.toggle}
              reset={reset}
              setIdsFunction={setIdsFunction}
              data={data}
              columns={
                columnVisibilityData?.length > 0 ? columnVisibilityData : columnss
              }
              leadFindLoading={allLeadFindLoading}
              selectBoxIdPassHandler={selectBoxIdPassHandler}
              isExistCounsilor={loginFindSuccess}
              component="leads"
              pagiantionEntry={pagiantionEntry}
              paginationPageNumber={paginationPageNumber}
              subMenu="All Leads"
              mainMenu="Leads"
              paginationDataFetching={paginationDataFetching}
              totalLeadCount={
                searchPagination ? searchPaginationCount :
                  filterPagination ? leadFilterRequestSuccess?.totalCount :
                    allLeadFindSuccess?.totalCount
              }
              viewedColumn={viewedColumn}
              searchPagination={searchPagination}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default All_leadListTable;